module.exports = __webpack_public_path__ + "resources/img/img_cloudz_modernization.aaf339df79b9422fc46a4fb7b691b862.png";